import React from 'react';
import styled from '../../../theme';
const Heading = styled.h2 `
  color: #3f414d;
  font-size: 17px;
  font-weight: 700;
  letter-spacing: normal;
  text-transform: uppercase;
  margin: ${({ isDesktop }) => (isDesktop ? '10px auto 5px' : '10px 10px 5px 10px')};
  max-width: 1140px;
  @media ${(props) => props.theme.mq.md} { 
    font-size: 24px;
    font-weight: normal;
  }
`;
const WidgetTitle = ({ title, isDesktop }) => (React.createElement(Heading, { isDesktop: isDesktop }, title));
export default WidgetTitle;
